import Image from "next/image"
import upscbanner1 from "../../assets/images/home/Mob_Banner/Achivers-2026-Web-Banner.jpg";
import upscbanner2 from "../../assets/images/home/Mob_Banner/Banner.png";
import CountUp from "react-countup";
// import phone from "../../assets/images/upsc/phone.png";
import AOS from "aos";
import "aos/dist/aos.css";
import NPFform from"../../components/NPFForm/npfform"
import Success from "../../assets/images/home/newicon/Success.jpg";
import Target1 from "../../assets/images/home/newicon/target.jpg";
import Faculty from "../../assets/images/home/newicon/Faculty.jpg";
import TestSeries from "../../assets/images/home/newicon/Testseries.jpg";
import Redrightarrow from  "../../assets/images/contact/Rarrow.png";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Carousel from 'react-bootstrap/Carousel';
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"),{ ssr: false });
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-form";
import Link from "next/link";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import redrightarrow from "../../assets/images/contact/arrow.png";
import useDownloader from "react-use-downloader";
import downloadicon from "../../assets/images/download.png";
import Head from "next/head";
import Emioption from "../../components/Service/emioption";
import Optionalplus from "../../components/Service/optionalplus";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
const UPSCClassroomOnline = () => {

  const {download} = useDownloader();

  const fileUrl = "/pdf/admission/SIA-Brochure-2025-bengaluru.pdf";
  const filename = "SIA-Brochure-2025-bengaluru.pdf"

   const banners = [
      { img: upscbanner1, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},
      { img: upscbanner2, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},  
    ]

  const feestructure =[
    {date:"04.09.2025", cont:"Regular", cont1:"11:00 am to 05:00 pm"},
    {date:"30.07.2025", cont:"Regular", cont1:"08:00 am to 01:30 pm"},
    {date:"27.06.2025", cont:"Regular", cont1:"08:00 am to 01:30 pm"},
    
  ]

  const feestructure2 =[
    {date:"05.07.2025",cont:"Weekend",cont1:"09:00 am to 01:00 pm"},
  ]

  const feestructure3 =[
   
    {date:"05.07.2025",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Tamil",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Mathematics",cont2:"09:00 am to 01:00 pm"},

    {date:"05.07.2025",cont:"Regular",cont1:"LAW",cont2:"02:30 pm to 05:00 pm"},
    {date:"07.07.2025",cont:"Regular",cont1:"Public Administration",cont2:"02:30 pm to 05:00 pm"},
    {date:"07.07.2025",cont:"Regular",cont1:"Anthropolgy",cont2:"05:30 pm to 08:00 pm"},
   
    {date:"07.07.2025",cont:"Regular",cont1:"Agriculture",cont2:"05:30 pm to 08:00 pm"},
    {date:"07.07.2025",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
    {date:"07.07.2025",cont:"Regular",cont1:"English Literature",cont2:"05:30 pm to 08:00 pm"},
    
    {date:"19.09.2025",cont:"Regular",cont1:"PSIR",cont2:"05:30 pm to 08:00 pm"},
    {date:"25.09.2025",cont:"Weekend",cont1:"Kannada Literature",cont2:"09:00 am to 01:00 pm"},

  ]

   const stats1 = [
      { value: 2900, suffix: "+", label: "IAS, IPS & IFS Selections", delay: 100 },
      { value: 202, label: "of 958 | UPSC CSE 2025", delay: 200 },
      { value: 9, label: "Govt Partnerships", delay: 300 },
    ];



const stats = [
  {
    value: 900,
    suffix: "+ hrs",
    label: " of comprehensive instruction",
    sub: "Classroom Teaching",
    aos: "zoom-in",
    delay: "100",
  },
  {
    value: 100,
    suffix: "+ hrs",
    label: "Individual Mentoring",
      sub: "One-on-One Guidance", 
      aos: "zoom-in",
    delay: "200",
  },
  {
    value: 102,
    suffix: "+",
    label: "Test Series",
    sub:"Extensive prelims and mains mock tests with detailed evaluation",  
    aos: "zoom-in",
    delay: "300",
  },
  {
    value: 8,
    suffix: " States",
    label: "Government-Recognized Training Partner",
    aos: "zoom-in",
    delay: "400",
  },
];

    const steps = [
  
  {
    title: "Classroom Teaching",
    desc: "900+ hours of comprehensive instruction",
  },
  {
    title: "Individual Mentoring",
    desc: "100+ hours of one-on-one guidance",
  },
  {
    title: "Test Series",
    desc: "Extensive prelims and mains mock tests with detailed evaluation",
  },
  {
    title: "Study Materials",
    desc: "Updated, curated content reflecting latest UPSC trends",
  },
   {
    title: "Interview Preparation",
    desc: "Free guidance program for Mains qualifiers",
  },
];

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "IAS Coaching in Bangalore | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/bengaluru/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/Pre-book-2024_Webbanner-Without-button.6686241b.webp",
    "description": "Transform your IAS dreams into reality with Top IAS Coaching in Bangalore. Expert guidance, comprehensive curriculum, and proven success awaityou."
  }
 
 
 const router = useRouter();
 
 useEffect(() => {
   AOS.init({
     duration: 800,
     easing: "ease-in-out",
     once: true,
     offset: 100,
   });
 }, []);
 
 useEffect(() => {
   const handleRouteChange = () => {
     AOS.refresh();
   };
 
   router.events.on("routeChangeComplete", handleRouteChange);
 
   return () => {
     router.events.off("routeChangeComplete", handleRouteChange);
   };
 }, [router.events]);
 
 
   
  return (
      <>
        <Head>
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="robots" content="noodp,noydir" />
          <meta name="robots" content="index,follow" />
          <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
          <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
          <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
          <title> IAS Coaching in Bangalore | Shankar IAS Academy</title>
          <meta name="title" content=" IAS Coaching in Bangalore | Shankar IAS Academy" />
          <meta name="description" content="Transform your IAS dreams into reality with Top IAS Coaching in Bangalore. Expert guidance, comprehensive curriculum, and proven success await you." />
          <link rel="canonical" href="https://www.shankariasacademy.com/bengaluru/" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content=" IAS Coaching in Bangalore | Shankar IAS Academy" />
          <meta property="og:description" content="Transform your IAS dreams into reality with Top IAS Coaching in Bangalore. Expert guidance, comprehensive curriculum, and proven success await you." />
          <meta property="og:url" content="https://www.shankariasacademy.com/bengaluru/" />
          <meta property="og:site_name" content="Shankar IAS Academy" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@shankarias" />
          {/* <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script> */}
        </Head>

  <Navbar title="upsc" />

  <div className="container">
    <div className="row">
      <div className="col-md-6">
        <div data-aos="fade-right" className= {`${styles.cardBox} d-flex flex-wrap gap-3 p-4`}>
          <h1>UPSC Civil Services Admission Open - 2026</h1>

            <Link href="/upsc-admission-anna-nagar" className= {`${styles.branchBtn} `}>
              Anna Nagar
            </Link>

            <Link href="/adyar" className={`${styles.branchBtn}`}>
              Adyar
            </Link>

            <Link href="/delhi" className={`${styles.branchBtn} `}>
              Delhi
            </Link>

            <Link href="/bengaluru" className={`${styles.branchBtn} `}>
              Bengaluru
            </Link>

            <Link href="/coimbatore" className={`${styles.branchBtn} `}>
              Coimbatore
            </Link>

            <Link href="/hyderabad" className={`${styles.branchBtn} `}>
              Hyderabad
            </Link>

            <Link href="/thiruvananthapuram" className={`${styles.branchBtn} `}>
              Trivandrum
            </Link>

            <Link href="/trichy" className={`${styles.branchBtn} `}>
              Trichy
            </Link>

            <Link href="/salem" className={`${styles.branchBtn} `}>
              Salem
            </Link>

            <Link href="/madurai" className={`${styles.branchBtn} `}>
              Madurai
            </Link>

            <Link href="/upsc-online-class" className={`${styles.branchBtn} `}>
              Online Class
            </Link>

            <Link href="/upsc-admission-nri" className={`${styles.branchBtn} `}>           
              NRI
            </Link>
        </div>

        <div data-aos="fade-left" className={`${styles.bestbg1}`}>
          <div className="p-4">
            <h2 className="text-center"> Pre Booking Open Now</h2> 
            <p>GSPCM will start on 16th February 2026. For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>9003190030</span> </p>
            <div className={`${styles.brochure} justify-content-center`}>
              <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Chennai-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                  <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-6 pt-3">
        <Carousel>
          {banners.map((e, index) =>
            <Carousel.Item key={index}>
              <Link href={e.link} rel="noreferrer">
                <Image
                className="carouselimage w-100 h-100"
                src={e.img}
                alt={e.alt}
                title="Shankar IAS Academy"
                /> 
              </Link>
            </Carousel.Item>
          )}
        </Carousel>
      </div>
    </div>
  </div>   

  {/*<Classroom_form branchname="Bengaluru"/>*/}

  <div className="container-fluid "  style={{
      background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",
      opacity: "1",
    }}>
    <div className="container">
      <div className= "row mt-4 mb-2 ">
        <div className={`${styles.admincontent} col-12 col-md-6 pt-4 mt-4`}>
          <div className={styles.heroCard} data-aos="fade-right">
            <span className={styles.badge}>India's Trusted UPSC Coaching</span>
            <h1 className={styles.title}>
              Best IAS Coaching in India
              <span> Shankar IAS Academy Bengaluru</span>
            </h1>
            <p className={styles.description}>
              Shankar IAS Academy stands as a pioneer in UPSC coaching, earning the reputation of being the Best IAS Academy in India through its consistent <b>track record</b> of producing top-ranking civil servants.
            </p>
            {/* Stats */}
            <div className={styles.statsRow}>
              {stats1.map((item, index) => (
                <div
                  key={index}
                  className={styles.statCircle}
                  data-aos="zoom-in"
                  data-aos-delay={item.delay}
                >
                  <span className={styles.circleGlow}></span>
                  <h3>
                    <CountUp
                      end={item.value}
                      duration={6.5}
                      suffix={item.suffix || ""}
                    />
                  </h3>
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
            {/* Features */}
            <div className={`${styles.featureGrid} pt-3`}>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="400">
              <span><Image src={Success} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>  High Success Rate 
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="500">
                <span><Image src={Target1} width="46" height="4 6" alt="New_icon" className="img-fluid mx-2" /></span> Prelims & Mains Integrated Coaching
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="600">
                  <span><Image src={Faculty} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span>Expert Faculty & Mentorship
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="700">
                <span><Image src={TestSeries} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>Advanced Test Series
              </div>

            </div>

            <div  className={`${styles.newachievernumber1} text-end pt-4 d-none d-md-block`} data-aos="fade-up" data-aos-delay="400">
              <Link href="#" className={`${styles.acheivermore}`} id=""  onclick="fbq('track', 'ButtonClick');">
                <span style={{ color: "rgb(66, 60, 60)", fontWeight:"bold", fontSize:"16px" }}>& More</span> <Image src={Redrightarrow} className={`${styles.logoimg} img-fluid`} alt="Chennai Icon" width={20} height={20} />
              </Link>
            </div>
          </div>
        </div>
        <div class="col-12  col-md-6 mt-4 mb-2">
          <p className={`${styles.contactheader} text-center`}>Enquiry</p>
          <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
          {/* <div class={`${styles.addmissionform} npf_wgts `} data-height="600px"   data-w="3f4274baec4df825dd72c5ff92d085ff"> </div>  */}
          <NPFform
            formId="3f4274baec4df825dd72c5ff92d085ff"
            height="600px"
            className="myForm"
          />
        </div>
      </div>
    </div>
  </div>

  <section className=" py-5 bg-light"  style={{
    background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",
    opacity: "1",
    }}>
      <div  className="container">
        <div className="">
          <div className="text-center ">
              <h2 className={styles.whysia}>
                Why Choose Shankar IAS Academy?
              </h2>
              <p className={styles.sectionDesc}>
                India's trusted institution for UPSC preparation with a structured,
                result-oriented learning ecosystem.
              </p>
          </div>
         {/* <p className={`${styles.acheiverrank} pt-4 text-center`}> <span style={{ color: "#db1b0d" , fontSize: "19px" }}>Shankar IAS Academy </span>has been Bangalore's most trusted name in UPSC preparation since 2004. Founded by<span style={{ color: "#0a0101" , fontWeight:"bold" }}> Mr. Shankar D., </span>our Bangalore center has helped thousands of aspirants transform their IAS dreams into reality</p>
          <h5 className="text-center fw-bold mb-4 ">
           <span style={{ color: "#4d4c55" }}> Our Track Record Speaks for Itself </span>
          </h5> */}
          <div className="container py-5">
              <div className="row g-4 justify-content-center pt-3">
                {stats.map((item, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-6 col-lg-3 d-flex justify-content-center"
                    data-aos={item.aos}
                    data-aos-delay={item.delay}
                  >
                    <div className={styles.choosecircle}>
                     
                      <h2 className={styles.statnumber}>
                        <CountUp end={item.value} duration={2.5} />
                        {item.suffix}
                      </h2>

                      <p className={styles.statlabel}>{item.label}</p>

                      {item.sub && (
                        <small className="text-muted">{item.sub}</small>
                      )}
                    </div>
                  </div>
                ))}
              </div>
          </div>
        </div>
      </div>
  </section>

  {/* <section className="d-block d-md-none bg-light">
    <div className="container">
      <div className="row g-4 justify-content-center ">
        <div className="">
            <p className={`${styles.acheiverrank} pt-4 text-center`}> <span style={{ color: "#db1b0d" , fontWeight:"bold" }}>Shankar IAS Academy </span>has been Bangalore's most trusted name in UPSC preparation since 2004. Founded by<span style={{ color: "#0a0101" , fontWeight:"bold" }}> Mr. Shankar D., </span>our Bangalore center has helped thousands of aspirants transform their IAS dreams into reality</p>
            <p className="text-center fw-bold mb-4 ">
            <span style={{fontSize:"16px" }}> Our Track Record Speaks for Itself </span>
            </p>
            <div className="card shadow-sm p-4">
              <ul>
                <li>2700+ IAS/IPS/IFS selections nationwide (highest in India)</li>
                <li>238 out of 1009 selections in UPSC CSE 2024</li>
                <li>25 candidates in Top 100 ranks</li>
                <li>Government-recognized training partner across 8 states</li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  </section> */}

  <div className="container-fluid md-mt-4 md-pt-5 pb-2">
    <div className={`${styles.startegy}`}>
      <div className="row g-4 mt-2">
        <div className={`${styles.sadhana}`}>
      <div class="container">
        <div className="row">
          <div className="col-12 col-md-4 text-white mt-2 p-2">UPSC GS-Mains Test Series 2025 (Moksha)<br /><a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a></div>
          <div className="col-12 col-md-4">
            <Link href="/two-year-upsc-program">
              <Image alt="sadhana" className="img-fluid" src={sadhana} />
            </Link>
          </div>

        <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
          <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
              <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
            </button>
        </div>
        </div>
      </div>
    </div>           
      </div>
    </div>
  </div>

  {/* Fee Details Section */}

  <section id="courseandfees " className="py-2">
    <div className="container py-5">
      <h2 className={`text-center mb-5 ${styles.mainTitle}`}>Course & Fee Structure – 2026</h2>
      <div className="row g-4">
        {/* ================= GS CARD ================= */}
        <div data-aos="fade-down" className="col-xl-4 col-lg-6 col-12">
          <div  className={`${styles.premiumCard} ${styles.highlightCard} h-100`}>
            <div className={styles.ribbon}>Admission Opening</div>
            <div className={styles.cardTop}>
              <h4>General Studies</h4>
              <p>Preliminary Cum Mains</p>
            </div>
            <div className={styles.priceBox}>
              ₹1,38,000
              <span>Inclusive of GST</span>
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont1}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ================= CSAT CARD ================= */}
        <div data-aos="fade-up" className="col-xl-4 col-lg-6 col-12">
          <div className={`${styles.premiumCard} h-100`}>
            <div className={styles.cardTop}>
              <h4>CSAT</h4>
            </div>
            <div className={styles.priceBox}>
              ₹12,000
              <span>Inclusive of GST</span>
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure2.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont1}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ================= OPTIONAL CARD ================= */}
        <div data-aos="fade-down" className="col-xl-4 col-lg-6 col-12">
          <div className={styles.premiumCard}>
            <div className={styles.cardTop}>
              <h4>Optional Subjects</h4>
            </div>

            <div className={styles.priceBox}>
              ₹34,000
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure3.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.cont1}</div>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont2}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
            <ObtionalButton />
        </div>
        
        <div data-aos="zoom-in" className={styles.premiumCard}>
          <div className={`${styles.facultyborder3} row h-100 `}>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
              <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle} `}><b>₹</b>1,84,000*</span><span>(inclusive of tax)</span></span>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right">
              <Emioption />                
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
              <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
            </div>

            <p className={`${styles.aboutparagraph1}  p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>
          </div>
        </div>

        <div className="row">
          <div  className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
            {/* <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;<b>₹5,000</b> Discount will be applicable for Integrated Course payment <b>(GS + CSAT + Optional)</b></p> */}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
          </div>
        </div>
      </div>
    </div>
  </section>

  <div className="container py-3">
    <h5 className={`text-center ${styles.bangmainTitle}`}>Program Features & Benefits</h5>
    <Program_Features />
  </div>

  {/* <div className={`${styles.sadhana}`}>
    <div class="container">
      <div className="row">
        <div className="col-12 col-md-4 text-white mt-2 p-2">UPSC GS-Mains Test Series 2025 (Moksha)<br /><a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a></div>
        <div className="col-12 col-md-4">
          <Link href="/two-year-upsc-program">
            <Image alt="sadhana" className="img-fluid" src={sadhana} />
          </Link>
        </div>

      <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
        <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
            <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
          </button>
      </div>
      </div>
    </div>
  </div> */}


  <section id="courses">
    <div className="container-fluid">
      <div className={`${styles.bestbg}`}>
        <h2 className="text-center">Why Aspirants Choose Shankar IAS Academy in Bangalore</h2>
        <div className="row g-4 mt-2">
          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-chalkboard-teacher"></i>
              </div>
              <h3>Expert Faculty with Proven Results</h3>
              <p>
                Our teaching team comprises handpicked educators from premier institutions and universities. Each faculty member brings years of experience in UPSC coaching, subject expertise, and a passion for mentoring future civil servants.
              </p>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-book-open"></i>
              </div>
              <h3>Comprehensive 360-Degree Preparation</h3>
              <p>
                We guide you through every stage of the UPSC journey:
              </p>
              <ul className="list-group list-group-flush">
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> <span style={{fontWeight:'600'}}>Prelims Preparation  –</span> Conceptual clarity with extensive MCQ practice </li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> <span style={{fontWeight:'600'}}>Mains Answer Writing  – </span> Structured techniques for high-scoring answers</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span><span style={{fontWeight:'600'}}> Current Affairs Integration –</span>Daily analysis aligned with UPSC patterns</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span><span style={{fontWeight:'600'}}> Interview Guidance  –</span>  Mock interviews with retired civil servants and experts</li> 
              </ul>
            </div>
          </div>
        
          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Interactive Learning Methodology</h3>
              <p>
                Our classroom sessions go beyond passive lectures. We use participatory teaching methods that encourage discussion, debate, and critical thinking skills essential for both Mains and the Personality Test.
              </p>
            </div>
          </div>
        
          <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-book-open"></i>
              </div>
              <h3>Personalized Attention</h3>
              <p>
                With limited batch sizes and an optimal student-faculty ratio, every aspirant at Shankar IAS Academy receives individual mentoring. No student is left behind.
              </p>
              
            </div>
          </div>

        <h2 className="text-center">What Makes Our Bangalore Centre Unique (Visualization)</h2>

          {/* <div className="position-relative mx-auto" style={{ maxWidth: "600px" }}>
            
            <div
              className="position-absolute top-0 start-50 translate-middle-x"
              style={{ width: "4px", height: "95%", background: "#c3c9cf" }}
            ></div>

            <ul className="list-unstyled m-0 p-0">
              {steps.map((step, index) => (
                <li key={index} className="position-relative mb-5">
                  
                  <div
                    className="position-absolute start-50 translate-middle rounded-circle shadow"
                    style={{
                      width: "40px",
                      height: "40px",
                      top: "0",
                      background: "#c50101",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      zIndex: 1,
                    }}
                  >
                    ✓
                  </div>

           
                  <div
                    className="bg-white shadow p-4 rounded-3 text-center mx-auto"
                    style={{ width: "90%", marginTop: "20px" }}
                  >
                    <h6 className="fw-bold text-dark">{step.title}</h6>
                    <p className="text-muted mb-0">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div> */}

          <div className="col-12 col-md-6 col-lg-12">
              <div className="card shadow-sm p-4">
                <div className="card-icon">
                  <i className="fas fa-book-open"></i>
                </div>
                <h3>Beyond UPSC – Multi-Exam Preparation</h3>
                <p>
                The knowledge and analytical skills you gain at Shankar IAS Academy prepare you for more than just the Civil Services Examination. Our students have successfully cleared:
                </p>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> Indian Forest Services (IFS)</li>
                  <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> State Public Service Commissions (KPSC, TNPSC, APPSC)</li>
                  <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> SSC CGL and other competitive examinations</li>
                </ul>
              </div>
          </div>

          <div className="col-12 col-md-6 col-lg-12">
              <div className="card shadow-sm p-4">
                <div className="card-icon">
                  <i className="fas fa-book-open"></i>
                </div>
                <h3>Our Philosophy – Building Future Leaders</h3>
                <p>
                  At Shankar IAS Academy, we believe that becoming an IAS officer is not just about clearing an exam – it's about becoming a responsible leader who serves the nation. Our curriculum focuses on developing:
                </p>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>In-depth subject knowledge</li>
                  <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Ethical reasoning and integrity</li>
                  <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Analytical and decision-making skills</li>
                  <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Empathy and public service orientation</li>
                </ul>
              </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* Our Acheivers */}
  <div className="container">
    <div className="row">
      <div className="col pt-4 pt-md-5 text-center">
          <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
          <p className={`${styles.sectionsubtitle}`}>
            Rank Holders from our academy
          </p>
      </div>
    </div>
  </div>

  <Acheiver />

  <section id="toppers">
    <div className="container">
      <div className="row">
        <div className="col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
        <Optionalplus /> 
        </div>
      </div>
    </div>
  </section>

  <BranchAddress />
  <Interest /> 
  <Footer />  

  </>
  )
}
  
  export default UPSCClassroomOnline;
